module.exports = __webpack_public_path__ + "static/media/StrengthMagazineSpread4.2e7117e7.jpg";